import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { BookingResource } from '../types/booking';
import { ResourceType } from '../utils/calendar';
import { useIdentity } from '../providers/IdentityProvider';
import { useCallback } from 'react';
import { useApiClient } from './useApiClient';
import useConfig from './useConfig';

const resourceTypeMap: Record<string, ResourceType> = {
  laundry: ResourceType.Laundry,
  gym: ResourceType.Gym,
  meeting_room: ResourceType.MeetingRoom,
  storage: ResourceType.Storage,
  other: ResourceType.Other,
};

export const useResources = (): UseQueryResult<BookingResource[]> => {
  const { id: deviceId } = useIdentity(
    useCallback((state) => ({ id: state.id }), []),
  );
  const apiClient = useApiClient();
  const config = useConfig();

  return useQuery({
    queryKey: ['resources', deviceId, config.bookingSystem],
    queryFn: async (): Promise<BookingResource[]> => {
      if (!deviceId) {
        console.error('[queryFn] Avbryter, deviceId saknas');
        throw new Error('deviceId saknas från IdentityProvider');
      }
      if (config.bookingSystem !== 'iloq') {
        return [];
      }

      const response =
        await apiClient.public.devices.getIloqResources(deviceId);

      return response.map((resource) => ({
        id: resource.resource_id,
        name: resource.name,
        type: resourceTypeMap[resource.type ?? 'other'] || ResourceType.Other,
      }));
    },
    enabled: !!deviceId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
